/** @format */

import { axiosInstance } from '@common/application/context/Providers';
import { RecordStatus } from '@common/application/enums';
import { TagCategory } from '@common/model/apiClient/TagCategory';
import { AxiosApiResponse } from '@common/types/api';
import { ElasticQueryOpts, ElasticSort } from '@common/types/elastic';
import { Nullable } from '@common/types/utils';
import { TagWithCategory } from '@molecules/TagMenu';

export class Tag {
  id: number;
  label: string;
  categoryId: number;
  category?: TagCategory;
  createdAt: Date;
  updatedAt: Date;
  deletedAt?: Nullable<Date>;
  status?: RecordStatus;

  constructor(categoryId: number, label: string) {
    this.categoryId = categoryId;
    this.label = label;
  }

  static list(entityType, query: string, queryOpts: ElasticQueryOpts, size: number, search_after?: ElasticSort): AxiosApiResponse<TagWithCategory[]> {
    // Ensure this code is not ran by SSR!
    if (typeof window !== 'undefined') {
      return axiosInstance.get(`/api/v1/tags`, {
        params: {
          sequence_id: 1,
          query,
          queryOpts: JSON.stringify(queryOpts),
          // sort: JSON.stringify(sort),
          search_after: JSON.stringify(search_after),
          size,
          entityType,
        },
      });
    }
    throw new Error();
  }

  static update(tag: Tag) {
    return axiosInstance
      .patch(`/api/v1/tags/${tag.id}`, {
        payload: {
          ...tag,
        },
      })
      .then((res) => ({ ...res.data }));
  }

  static delete(tagId: number) {
    return axiosInstance.delete(`/api/v1/tags/${tagId}`, {}).then((res) => ({ ...res.data }));
  }

  static undelete(tagId: number) {
    return axiosInstance
      .patch(`/api/v1/tags/${tagId}`, {
        payload: { deletedAt: null },
      })
      .then((res) => ({ ...res.data }));
  }
  create() {
    return axiosInstance
      .post(`/api/v1/tags`, {
        payload: {
          ...this,
        },
      })
      .then((res) => ({ ...res.data }));
  }
}
